<template>
  <div>
    <div class="content">
      <div class="left">
        <el-row class="left-top">
          <el-col :span="8">
            <div class="record-bg">
              <div class="span-one">
                {{ resData.dossierInfo.dossierTotalNum }}份
              </div>
              <div class="span-two">
                上报档案总数
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="record-bg">
              <div class="span-one">
                {{ resData.dossierInfo.noReportingNum }}所
              </div>
              <div class="span-two">
                未上报档案学校
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="record-bg">
              <div>
                <el-progress
                  class="edu-file-progress"
                  :width="40"
                  :heitht="40"
                  type="circle"
                  :percentage="resData.dossierInfo.reportingScale * 100"
                  color=" #5edbff"
                ></el-progress>
              </div>
              <div class="span-three">
                档案填报率
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row class="left-bottom">
          <div class="table-List-bg">
            档案上报概括
          </div>
          <div class="table-list-content">
            <div
              class="table-item"
              v-for="(item, index) in recordList"
              :key="index"
            >
              <div class="item-left">
                <img
                  :src="require('@/assets/img/eduBigFile2/' + imageList[index])"
                  alt=""
                />
                <div class="txt">
                  {{ item.name }}
                </div>
              </div>
              <div class="item-right">
                <div class="txt">
                  {{ item.value }}
                </div>
                <div class="num">所</div>
              </div>
            </div>
          </div>
        </el-row>
      </div>
      <div class="center" style="margin-top:10px">
        <div>
          <hidden-danger-num
            :num="resData.dossierInfo.dossierTotalNum"
            msg="上报档案总数"
          ></hidden-danger-num>
        </div>
        <div class="map">
          <map-content
            :cityArr="cityArr"
            :cityCode="cityCode"
            @refreshData="refreshData"
            :tooltip="tooltip"
            :isbaifen="true"
            :pieces="pieces"
          ></map-content>
        </div>
      </div>
      <div class="right">
        <div class="right-title">
          重点档案数据统计
        </div>
        <div class="right-content">
          <div class="key-file-item">
            <div
              class="key-file-item-left"
              @click="
                fileClick(resData.keyArchives.schoolBusNum, '校车档案', 2)
              "
            >
              <div class="item-num">
                <span style="font-size:18px;color:#D7DEFF">
                  {{ resData.keyArchives.schoolBusNum }}
                </span>
                份
              </div>
              <div class="item-name">校车档案数</div>
            </div>
            <div
              class="key-file-item-right"
              @click="
                fileClick(resData.keyArchives.fireBlanketNum, '灭火毯档案', 4)
              "
            >
              <div class="item-num">
                <span style="font-size:18px;color:#D7DEFF">
                  {{ resData.keyArchives.fireBlanketNum }} </span
                >份
              </div>
              <div class="item-name">灭火毯档案数</div>
            </div>
          </div>
          <div class="key-file-item">
            <div
              class="key-file-item-left"
              @click="
                fileClick(
                  resData.keyArchives.otherFireFightingNum,
                  '其它消防档案',
                  6
                )
              "
            >
              <div class="item-num">
                <span style="font-size:18px;color:#D7DEFF">
                  {{ resData.keyArchives.otherFireFightingNum }}</span
                >
                份
              </div>
              <div class="item-name">其它消防档案数</div>
            </div>
            <div
              class="key-file-item-right"
              @click="
                fileClick(
                  resData.keyArchives.fireExtinguisherNum,
                  '灭火器档案',
                  3
                )
              "
            >
              <div class="item-num">
                <span style="font-size:18px;color:#D7DEFF">
                  {{ resData.keyArchives.fireExtinguisherNum }}</span
                >
                份
              </div>
              <div class="item-name">灭火器档案数</div>
            </div>
          </div>
          <div class="key-file-item">
            <div
              class="key-file-item-left"
              @click="fileClick(resData.keyArchives.canteenNum, '食堂档案', 0)"
            >
              <div class="item-num">
                <span style="font-size:18px;color:#D7DEFF">
                  {{ resData.keyArchives.canteenNum }}</span
                >
                份
              </div>
              <div class="item-name">食堂档案数</div>
            </div>
            <div
              class="key-file-item-right"
              @click="
                fileClick(
                  resData.keyArchives.leftBehindChildrenNum,
                  '留守儿童档案',
                  9
                )
              "
            >
              <div class="item-num">
                <span style="font-size:18px;color:#D7DEFF">
                  {{ resData.keyArchives.leftBehindChildrenNum }}</span
                >
                份
              </div>
              <div class="item-name">
                留守儿童档案数
              </div>
            </div>
          </div>
          <div class="key-file-item">
            <div
              class="key-file-item-left"
              @click="
                fileClick(resData.keyArchives.fireHydrantNum, '消火栓档案', 5)
              "
            >
              <div class="item-num">
                <span style="font-size:18px;color:#D7DEFF">
                  {{ resData.keyArchives.fireHydrantNum }}</span
                >
                份
              </div>
              <div class="item-name">消火栓档案数</div>
            </div>
            <div
              class="key-file-item-right"
              @click="
                fileClick(resData.keyArchives.safeApparatusNum, '器械档案', 8)
              "
            >
              <div class="item-num">
                <span style="font-size:18px;color:#D7DEFF">
                  {{ resData.keyArchives.safeApparatusNum }}</span
                >
                份
              </div>
              <div class="item-name">器械档案数</div>
            </div>
          </div>
          <div class="key-file-item">
            <div
              class="key-file-item-left"
              @click="
                fileClick(resData.keyArchives.securityGuardNum, '安保档案', 1)
              "
            >
              <div class="item-num">
                <span style="font-size:18px;color:#D7DEFF">
                  {{ resData.keyArchives.securityGuardNum }}</span
                >
                份
              </div>
              <div class="item-name">安保档案数</div>
            </div>
            <div
              class="key-file-item-right"
              @click="
                fileClick(
                  resData.keyArchives.emergencyAccessNum,
                  '安全通道档案',
                  7
                )
              "
            >
              <div class="item-num">
                <span style="font-size:18px;color:#D7DEFF">
                  {{ resData.keyArchives.emergencyAccessNum }}</span
                >
                份
              </div>
              <div class="item-name">安全通道档案数</div>
            </div>
          </div>
          <div class="key-file-item">
            <div
              class="key-file-item-left"
              @click="
                fileClick(resData.keyArchives.safeDrillPlanNum, '应急预案', 10)
              "
            >
              <div class="item-num">
                <span style="font-size:18px;color:#D7DEFF">
                  {{ resData.keyArchives.safeDrillPlanNum }}</span
                >
                份
              </div>
              <div class="item-name">应急预案数</div>
            </div>
            <div
              class="key-file-item-right"
              @click="
                fileClick(
                  resData.keyArchives.secureDisciplineNum,
                  '安全制度管理',
                  11
                )
              "
            >
              <div class="item-num">
                <span style="font-size:18px;color:#D7DEFF">
                  {{ resData.keyArchives.secureDisciplineNum }}</span
                >
                份
              </div>
              <div class="item-name">安全制度管理数</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <file-dialog
      :show="fileListShow"
      @close="dialogClose"
      :title="dialogTitle"
      :searchParams="searchParams"
    ></file-dialog>
  </div>
</template>

<script>
import theNowTime from "./components/theNowTime";
import hiddenDangerNum from "./components/hiddenDangerNum";
import mapContent from "./components/mapContent";
import fileDialog from "./components/fileDialog";
export default {
  name: "",
  components: {
    theNowTime,
    hiddenDangerNum,
    mapContent,
    fileDialog
  },
  props: {},
  data() {
    return {
      eduInfo: JSON.parse(sessionStorage.getItem("eduInfo")),
      resData: {
        dossierReporting: {}, //档案上报概括
        dossierInfo: {
          reportingScale: 0,
          dossierTotalNum: 0
        }, //档案信息
        keyArchives: {} //重点档案数据统计
      },
      recordList: [],
      totalRisk: 0, //区域内风险
      progressColor: ["yellow", "red"],
      imageList: [
        "1.png",
        "2.png",
        "3.png",
        "4.png",
        "5.png",
        "6.png",
        "7.png"
      ],
      cityArr: [],
      cityCode: "",
      pieces: [
        { gt: 0.95, label: "95%以上", color: "#6363FF" },
        { gt: 0.8, lte: 0.95, label: "80%~95%", color: "#FFFF54" },
        { gt: 0.6, lte: 0.8, label: "60%~80%", color: "#FF995A" },
        { lte: 0.6, label: "60%以下", color: "#FF6464" }
      ],
      tooltip: [
        {
          title: "上报率",
          value: "value"
        }
      ],
      fileListShow: false,
      dialogTitle: "",
      searchParams: {
        eduId: "",
        regionCode: "",
        eduBuresuType: "",
        type: ""
      }
    };
  },
  created() {
    let req = {
      eduId: this.eduInfo.eduId,
      regionCode: parseInt(this.eduInfo.regionCode),
      eduBuresuType: this.eduInfo.eduBuresuType
    };
    this.getDossierInfo(req);
  },
  mounted() {},
  computed: {},
  watch: {},
  methods: {
    refreshData(obj) {
      let req = {
        eduId: obj.eduId,
        regionCode: parseInt(obj.regionCode),
        eduBuresuType: obj.eduBuresuType
      };
      this.getDossierInfo(req);
    },
    async getDossierInfo(req) {
      let self = this;
      let res = await self.$Http.getDossierInfo(req);
      self.cityCode = req.regionCode + "";
      if (res.code == 200) {
        if (res.data) {
          self.resData = res.data;
          self.getRecordList(res.data.dossierReporting);
          self.schoolList = self.resData.subSchoolInfo || [];
          let data = res.data.areaMapInfos || [];
          self.cityArr = data.map((item) => {
            item.name = item.regionName;
            item.value = item.reportingScale;
            return item;
          });
          self.searchParams.eduId = req.eduId;
          self.searchParams.regionCode = req.regionCode;
          self.searchParams.eduBuresuType = req.eduBuresuType;
        }
      } else if (res.code == 101) {
      } else {
      }
    },
    getRecordList(object) {
      let self = this;
      self.recordList = [];
      for (const key in object) {
        if (object.hasOwnProperty(key)) {
          const element = object[key];
          let name = "";
          switch (key) {
            case "schoolBusNum":
              name = "校车档案";
              break;
            case "fireFightingNum":
              name = "消防档案";
              break;
            case "exceptionalNum":
              name = "特殊体质上报档案";
              break;
            case "foodInformationNum":
              name = "食堂档案";
              break;
            case "leftBehindChildrenNum":
              name = "留守儿童上报档案";
              break;
            case "safeApparatusNum":
              name = "器械上报档案";
              break;
            case "securityGuardNum":
              name = "安保上报档案";
              break;
            default:
              break;
          }
          self.recordList.push({
            name: name,
            value: element
          });
        }
      }
    },
    fileClick(number, title, val) {
      if (number && number != 0) {
        this.fileListShow = true;
        this.dialogTitle = title;
        this.searchParams.type = val;
      } else {
        this.$message("当前档案无数据，请选择其他档案查看！");
      }
    },
    dialogClose() {
      this.fileListShow = false;
    }
  },
  destroyed() {}
};
</script>

<style lang="scss" scoped>
.content {
  margin-top: 30px;
  display: flex;
  padding: 0 3.75% 0 3.8%;
  justify-content: space-between;
  .left {
    margin-top: 10px;
    width: 460px;
    .left-top {
      background: url("~@/assets/img/eduBigFile2/left-top-bg.png") center center
        no-repeat;
      background-size: 100% 100%;
    }
    .left-bottom {
      margin-top: 20px;
      background: url("~@/assets/img/eduBigFile2/left-bottom-bg.png") center
        center no-repeat;
      background-size: 100% 100%;
    }
  }
  .center {
    width: 800px;
    background: url("~@/assets/img/eduBigFile2/center-bg.png") center center
      no-repeat;
    background-size: 100% 100%;
    .map {
      padding-top: 40px;
      width: 100%;
      height: 400px;
    }
  }
  .right {
    width: 460px;
    margin-top: 10px;
    background: url("~@/assets/img/eduBigFile2/right-bg.png") center center
      no-repeat;
    background-size: 100% 100%;
    .right-title {
      padding: 12px 0 0 18px;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #6ff3fa;
    }
    .right-content {
      padding: 0 40px;
    }
  }
}
.record-bg {
  margin: 40px 0px 30px 30px;
  width: 100px;
  // height: 240px;
  // background: url("~@/assets/img/fileIcon/record-icon-two.png") center center
  //   no-repeat;
  // background-size: 100% 100%;
  text-align: center;
  .span-one {
    font-size: 18px;
    color: #fff1a8;
  }
  .span-two {
    margin-top: 20px;
    color: white;
    font-size: 14px;
  }
  .span-three {
    color: white;
    font-size: 14px;
  }
  .el-progress {
    position: relative;
    top: -10px;
  }
}
.table-List-bg {
  padding: 16px 0 0 18px;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #6ff3fa;
}
.table-list-content {
  height: 580px;
  padding: 0 40px;
  margin-top: 10px;
  overflow: scroll;
  scrollbar-width: none;
}
.table-item {
  margin-top: 10px;
  padding: 0 20px;
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: url("~@/assets/img/eduBigFile2/left-bottom-item-bg.png") center
    center no-repeat;
  background-size: 100% 100%;
  .item-left {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    img {
      width: 25px;
      height: 25px;
    }
    .txt {
      padding-left: 10px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #cecece;
    }
  }
  .item-right {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .txt {
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #67e2e9;
    }
    .num {
      padding-left: 15px;
      font-size: 12px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #cecece;
    }
  }
}
.key-file-item {
  width: 100%;
  // height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  margin-top: 20px;
  .key-file-item-left {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 200px;
    height: 100px;
    font-size: 14px;
    text-align: center;
    color: rgba(215, 222, 255, 0.8);
    background: url("~@/assets/img/eduBigFile2/right-item-bg.png") center center
      no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
    .item-num {
      font-size: 19px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #67e2e9;
      span {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #cecece;
      }
    }
    .item-name {
      margin-top: 2px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #cecece;
    }
  }
  .key-file-item-right {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-left: 30px;
    width: 200px;
    height: 100px;
    text-align: center;
    color: rgba(215, 222, 255, 0.8);
    background: url("~@/assets/img/eduBigFile2/right-item-bg.png") center center
      no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
    .item-num {
      font-size: 19px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #67e2e9;
      span {
        font-size: 12px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #cecece;
      }
    }
    .item-name {
      margin-top: 2px;
      font-size: 14px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #cecece;
    }
  }
}
.edu-file-progress {
  /deep/ &.el-progress--circle {
    .el-progress__text {
      font-size: 14px;
      font-weight: 500;
      color: #fff1a8;
      width: 62%;
      height: 62%;
      line-height: 26px;
      text-align: center;
      border-radius: 50%;
      box-shadow: 0px -3px 7px 0px #5edbff inset;
      left: 20%;
      top: 51%;
    }
    .el-progress-circle__track {
      stroke: rgba(94, 219, 255, 0.67) !important;
    }
    .el-progress-circle__path {
      stroke-dashoffset: 180px;
    }
    .el-progress-circle {
      transform: rotate(180deg);
      -ms-transform: rotate(180deg); /* IE 9 */
      -moz-transform: rotate(180deg); /* Firefox */
      -webkit-transform: rotate(180deg); /* Safari 和 Chrome */
      -o-transform: rotate(180deg); /* Opera */
    }
    .el-progress-circle__path {
      border-radius: 50%;
      box-shadow: 0px -3px 7px 0px #5edbff inset;
    }
  }
}
</style>
